import { Injectable } from "@angular/core";
import { Network } from "@ionic-native/network";
import { Platform } from "ionic-angular";

@Injectable()
export class Connectivity {
  onDevice: boolean;

  constructor(public platform: Platform, public network: Network) {
    this.onDevice = this.platform.is("cordova");
  }

  isOnline() {
    if (this.onDevice) {
      if (this.network.type !== "none") {
        return true;
      } else {
        return false;
      }
    }
    else{
      return  navigator.onLine;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/connectivity/connectivity.ts